import React from "react";

export default function Footer() {
  return (
    <footer className="bg-[#0D1729]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-6 h-6 border border-white/70 relative">
                <span className="absolute inset-1 bg-white/90" />
              </span>
              <span className="mono-label text-white">SAUDERTON · FORENSICS</span>
            </div>
            <p className="text-slate-400 text-sm mt-6 max-w-sm leading-relaxed">
              Boutique blockchain forensics and legacy wallet recovery for high-asset litigation.
              Retainer-only. Privileged engagements. No retail services.
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="mono-label mb-4">DIRECTORY</div>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li><a href="#services" className="hover:text-white transition-colors" data-testid="footer-services">Engagement Tiers</a></li>
              <li><a href="#methodology" className="hover:text-white transition-colors" data-testid="footer-methodology">Methodology</a></li>
              <li><a href="#about" className="hover:text-white transition-colors" data-testid="footer-about">Principal</a></li>
              <li><a href="#inquiry" className="hover:text-white transition-colors" data-testid="footer-inquiry">Case Intake</a></li>
              <li><a href="/media" className="hover:text-white transition-colors" data-testid="footer-media">Media Contact</a></li>
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4">
            <div className="mono-label mb-4">PROTOCOL</div>
            <ul className="space-y-3 text-slate-300 text-sm">
              <li>Privileged intake channel</li>
              <li>Auditable chain-of-custody</li>
              <li>Air-gapped forensic environment</li>
              <li>Escrowed key-handback</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 border-t border-slate-800/70 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <span className="mono-label text-slate-500">
            © {new Date().getFullYear()} · SAUDERTON FORENSICS · ALL RIGHTS RESERVED
          </span>
          <div className="flex items-center gap-8">
            <a href="/admin/login" className="mono-label hover:text-white transition-colors" data-testid="footer-admin-link">OPERATOR LOGIN</a>
            <span className="mono-label text-slate-500">NOT LEGAL ADVICE</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
